// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2GR9f","margin-top18":"style_margin-top18__2iljE","button-div":"style_button-div__xXKP0","square":"style_square__1FhwD"};